export enum VirtualPrinterKey {
  noPrinter = 'noPrinter',
  guestPrinter = 'guestPrinter',
}
